// extracted by mini-css-extract-plugin
export default {"container":"Report_container__IyHbj","btn":"Report_btn__2SRR5"};